var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.user
    ? _c("section", [
        _c("div", { staticClass: "row mt-3" }, [
          _c("div", { staticClass: "col-lg-6 col-12" }, [
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("message.home.my_coins_and_points")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card shadow-sm" }, [
              _c(
                "div",
                { staticClass: "card-body p-2", attrs: { role: "button" } },
                [
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex-fill text-center",
                        on: {
                          click: function($event) {
                            return _vm.goToPage("/user/credits")
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-usd-circle -icon-coins"
                        }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.user.totalCredits) +
                            " " +
                            _vm._s(_vm.$t("message.coins")) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticStyle: {
                        width: "1px",
                        height: "40px",
                        "background-color": "#E0E0E0"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "flex-fill text-center",
                        on: {
                          click: function($event) {
                            return _vm.goToPage("/rewards")
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-trophy-alt -icon-coins"
                        }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("prettyNumber")(_vm.user.totalPoints)
                            ) +
                            " " +
                            _vm._s(_vm.$t("message.rewards.points")) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9df17f0c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9df17f0c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/UserCoinsPoints.vue
// module id = 1491
// module chunks = 0